<template>
  <div class="wrapper">
    <div class="content">{{ label }}</div>
    <div class="indicator" :style="{ width: percent + '%' }"></div>
  </div>
</template>

<script>
export default {
  name: 'Progress',
  props: ['num_sent', 'num_total'],
  computed: {
    percent() {
      return 100 * this.num_sent / this.num_total;
    },
    label() {
      return `(${this.num_sent} of ${this.num_total}: ${Math.round(this.percent)}%)`
    },
  }
}
</script>

<style scoped lang="scss">
  .wrapper {
    position: relative;

    .content {
      position: relative;
      z-index: 2;
    }
    .indicator {
      position: absolute;
      top: 0;
      bottom: 0;
      z-index: 1;
      transition: width .4s ease;
      width: 0;
      background: var(--v-primary-lighten5);
    }
  }
</style>
